import { Children, type ReactNode } from "react";

export type ActionBarProps = {
  secondary?: ReactNode;
  children: ReactNode;
};

/** Responsive action row. Secondary content stays left on wide containers and last on compact ones. */
export function ActionBar({ children, secondary }: ActionBarProps): ReactNode {
  return (
    <div className="@container">
      <div className="flex flex-col-reverse items-stretch gap-sm pt-space-md @md:flex-row @md:items-center">
        {secondary && <div className="w-full @md:mr-auto @md:w-fit">{secondary}</div>}
        {Children.map(children, (child) => (
          <div className="w-full @md:w-fit">{child}</div>
        ))}
      </div>
    </div>
  );
}
